module.exports = "https://static.zego.com/_next/static/images/TC-073d1a2bce8e1bcb0da1554a23a915df.svg";